module.exports = __webpack_public_path__ + "img/72ne.ea784047.svg";